import { create } from '@zebing/js-bridge'

let ready = false
const list = []

const onReady = function () {
  ready = true
  list.map(fn => fn())
}

// jsBridge 适配器
const adapter = [
  {
    platform: () => true,

    support: name => typeof (window.h5api || {})[name] === 'function',

    run (name, options) {
      window.h5api[name](JSON.stringify(options))
    }
  }
]

// 本地开发模拟原生交互
if (process.env.BUILD_ENV === 'development') {
  const bridgeMethods = require(`../../../bridge.methods.js`)

  window.h5api = bridgeMethods
}

let id = 0
let port = window.location.search
  .slice(1)
  .split('&')
  .find(item => /^port/.test(item))
port = port ? port.replace('port=', '') : '12345'
let socket = {}

setTimeout(() => {
  onReady()
}, 6000)

try {
  socket = new WebSocket(`ws://localhost:${port}`)
} catch (err) {
  onReady()
}

socket.onclose = function () {
  onReady()
  console.error('jsBridge socket onclose')
  if (localStorage.getItem('source') === 'pc') {
    localStorage.clear()
    window.location.href = `${process.env.VUE_APP_AUTH}/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${process.env.VUE_APP_CALLBACKURL}&state=sdfsfs&scope=basic&response_type=code&signup_uri=${process.env.VUE_APP_SIGNUP_URI}`
  }
}
socket.onerror = function (error) {
  console.error('jsBridge socket onerror' + error)
  if (localStorage.getItem('source') === 'pc') {
    localStorage.clear()
    window.location.href = `${process.env.VUE_APP_AUTH}/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${process.env.VUE_APP_CALLBACKURL}&state=sdfsfs&scope=basic&response_type=code&signup_uri=${process.env.VUE_APP_SIGNUP_URI}`
  }
}

socket.onmessage = event => {
  let data = event.data
  if (typeof data === 'string') {
    data = JSON.parse(data)
  }

  if (data.type === 10) {
    // 将方法 注册到 h5api 属性
    if (!window.h5api) {
      window.h5api = data.data.h5api.methods.reduce(
        (obj, [methodsName, methodId]) => {
          obj[methodsName] = function (arg = '{}') {
            const data = {
              type: 6,
              object: 'h5api',
              method: methodId,
              args: [arg],
              id: id++
            }

            socket.send(JSON.stringify(data))
          }
          return obj
        },
        {}
      )

      data.data.h5api.signals.map(item => {
        const data = {
          type: 7,
          object: 'h5api',
          signal: item[1]
        }
        socket.send(JSON.stringify(data))
      })
    }

    // jsBridge 环境是否连接
    if (!ready) {
      onReady()
    }

    // 调用原生方法数据相应
  } else if (data.type === 1) {
    const result = JSON.parse((data.args && data.args[0]) || '{}')
    const callback = result.callback
    if (window[callback]) {
      delete result.callback
      window[callback](result)
    } else {
      // 修改系统配置
      if (data.signal === 5) {
        window.location.reload()
      }
    }
  }
}

socket.onopen = function () {
  // 获取原生接口信息
  socket.send(JSON.stringify({ type: 3, id: id++ }))
}
export default create(adapter)

export function init (callback) {
  if (!ready) {
    list.push(callback)
    return
  }

  callback()
}
